/* eslint-disable max-len */
import {
  createHashRouter,
  RouterProvider,
  redirect,
} from 'react-router-dom';
import React, { lazy } from 'react';

import Home from 'src/pages/Home';
import Admin from 'src/pages/Admin';
import Login from 'src/pages/Login/Login';
import LazyComponent from 'src/components/LazyComponent';

const Authentication = lazy(() => import('src/pages/Authentication'));
const AuthenticationPerson = lazy(() => import('src/pages/Authentication/person'));
const AuthenticationOffice = lazy(() => import('src/pages/Authentication/office'));
const Search = lazy(() => import('src/pages/Search'));
const SearchAdd = lazy(() => import('src/pages/SearchAdd'));
const SearchDetail = lazy(() => import('src/pages/SearchDetail'));
const UseManagement = lazy(() => import('src/pages/UserManagement'));
const UserManagementDetail = lazy(() => import('src/pages/UserManagementDetail'));
const UserProfile = lazy(() => import('src/pages/UserProfile'));
const ContractManagement = lazy(() => import('src/pages/ContractManagement'));
const AuthBan = lazy(() => import('src/pages/AdminAuthBan'));
const FaceAuthResult = lazy(() => import('src/pages/FaceAuthResult'));
const AccountAuth = lazy(() => import('src/pages/AccountAuth'));
const AccountAuthIntegration = lazy(() => import('src/pages/AccountAuthIntegration'));
const RechargeRecord = lazy(() => import('src/pages/RechargeRecord'));
const RechargeRecordSystem = lazy(() => import('src/pages/RechargeRecord/manage'));
const DeductionRecord = lazy(() => import('src/pages/DeductionRecord'));
const DeductionRecordSystem = lazy(() => import('src/pages/DeductionRecord/manage'));
const BalanceManagement = lazy(() => import('src/pages/BalanceManagement'));
const Recharge = lazy(() => import('src/pages/Recharge'));
const ProtocolIndex = lazy(() => import('src/pages/Protocols'));

const router = createHashRouter([
  {
    path: '/',
    loader: () => redirect('/home'),
  },
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/admin',
    element: <Admin />,
    children: [
      {
        path: 'authentication',
        element: <LazyComponent AsyncComponent={Authentication} />,
      },
      {
        path: 'authenticationPerson',
        element: <LazyComponent AsyncComponent={AuthenticationPerson} />,
      },
      {
        path: 'authenticationOffice',
        element: <LazyComponent AsyncComponent={AuthenticationOffice} />,
      },
      {
        path: 'search',
        element: <LazyComponent AsyncComponent={Search} />,
      },
      {
        path: 'search/add',
        element: <LazyComponent AsyncComponent={SearchAdd} />,
      },
      {
        path: 'search/detail/:id',
        element: <LazyComponent AsyncComponent={SearchDetail} />,
      },
      {
        path: 'useManagement',
        element: <LazyComponent AsyncComponent={UseManagement} />,
      },
      {
        path: 'usermanagement/detail/:id',
        element: <LazyComponent AsyncComponent={UserManagementDetail} />,
      },
      {
        path: 'userProfile',
        element: <LazyComponent AsyncComponent={UserProfile} />,
      },
      {
        path: 'contractManagement',
        element: <LazyComponent AsyncComponent={ContractManagement} />,
      },
      {
        path: 'rechargeRecord',
        element: <LazyComponent AsyncComponent={RechargeRecord} />,
      },
      {
        path: 'rechargeRecordSystem',
        element: <LazyComponent AsyncComponent={RechargeRecordSystem} />,
      },
      {
        path: 'deductionRecord',
        element: <LazyComponent AsyncComponent={DeductionRecord} />,
      },
      {
        path: 'deductionRecordSystem',
        element: <LazyComponent AsyncComponent={DeductionRecordSystem} />,
      },
      {
        path: 'balanceManagement',
        element: <LazyComponent AsyncComponent={BalanceManagement} />,
      },
      {
        path: 'recharge',
        element: <LazyComponent AsyncComponent={Recharge} />,
      },
      {
        path: 'auth-ban',
        element: <LazyComponent AsyncComponent={AuthBan} />,
      },
      {
        path: 'account-auth',
        element: <LazyComponent AsyncComponent={AccountAuth} />,
      },
      {
        path: 'account-auth-integration',
        element: <LazyComponent AsyncComponent={AccountAuthIntegration} />,
      },
    ],
  },
  {
    path: '/faceAuthResult',
    element: <LazyComponent AsyncComponent={FaceAuthResult} />,
  },
  {
    path: '/protocols',
    element: <LazyComponent AsyncComponent={ProtocolIndex} />,
  },
]);

export default function Router() {
  return <RouterProvider router={router} />;
}
